import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      SETTINGS: "Innstillinger",
      HOW_WOULD_YOU_LIKE_US_TO_COMMUNICATE:
        "Velg hvordan du vil at vi skal kommunisere til deg:",
      VIA_EMAIL: "På e-post",
      I_WOULD_LIKE_TO_RECEIVE_VIA_EMAIL:
        "Jeg vil motta middagstips og tilbud på e-post.",
      VIA_SMS: "På SMS",
      I_WOULD_LIKE_TO_RECEIVE_VIA_SMS:
        "Jeg vil ha leveranseinformasjon, middagstips og tilbud på SMS.",
      VIA_PHONE: "På telefon",
      I_WOULD_LIKE_TO_RECEIVE_VIA_PHONE:
        "Jeg vil motta middagstips og tilbud på telefon.",
      VIA_SOCIAL_MEDIA: "På sosiale medier",
      I_WOULD_LIKE_TO_RECEIVE_VIA_SOCIAL_MEDIA:
        "Jeg vil motta middagstips og tilbud på sosiale medier.",
      // extra checbox on norwegian brands
      VIA_PRINT: "Via brev",
      I_WOULD_LIKE_TO_RECEIVE_VIA_PRINT:
        "Jeg vil motta middagstips og tilbud via brev.",
      SAVE_BUTTON_TEXT: "Lagre endringer",
      REMINDERS: "Bestillingspåminnelse på SMS",
      GET_NOTIFIED_BEFORE_DEADLINE:
        "Få beskjed om min kommende bestilling før fristen for endringer.",
      WILL_BE_NOTIFIED_BEFORE_DEADLINE:
        "Jeg ønsker å bli varslet om min neste bestilling før fristen for endringer har gått ut.",
      CAN_TAKE_UP_TO_24_HOURS:
        "Vær oppmerksom på at det kan ta opptil 24 timer før endringen er registrert.",
      YOUR_SETTINGS_HAVE_BEEN_UPDATED: "Dine innstillinger er oppdatert.",
    },
    dk: {
      SETTINGS: "Indstillinger",
      HOW_WOULD_YOU_LIKE_US_TO_COMMUNICATE:
        "Hvordan ønsker du, vi skal kommunikere med dig?",
      VIA_EMAIL: "Via e-mail",
      I_WOULD_LIKE_TO_RECEIVE_VIA_EMAIL:
        "Jeg vil gerne modtage opskrifter, tips og tilbud på e-mail.",
      VIA_SMS: "Via SMS",
      I_WOULD_LIKE_TO_RECEIVE_VIA_SMS:
        "Jeg vil gerne modtage leveringsinformation, opskrifter, tips og tilbud på SMS.",
      VIA_PHONE: "Via telefon",
      I_WOULD_LIKE_TO_RECEIVE_VIA_PHONE:
        "Jeg vil gerne modtage opskrifter, tips og tilbud på telefon.",
      VIA_SOCIAL_MEDIA: "Via sociale medier",
      I_WOULD_LIKE_TO_RECEIVE_VIA_SOCIAL_MEDIA:
        "Jeg vil gerne modtage opskrifter, tips og tilbud på sociale medier.",
      SAVE_BUTTON_TEXT: "Gem ændringer",
      REMINDERS: "Bestillingspåmindelse på SMS",
      GET_NOTIFIED_BEFORE_DEADLINE:
        "Vi sender gerne en påmindelse om din kommende ordre før deadline for bestillingsændringer.",
      WILL_BE_NOTIFIED_BEFORE_DEADLINE:
        " Jeg vil gerne modtage en SMS-påmindelse om min kommende ordre før deadline for bestillingsændringer.",
      CAN_TAKE_UP_TO_24_HOURS:
        "Bemærk, at det kan tage op til 24 timer, før dine ændringer er registreret.",
      YOUR_SETTINGS_HAVE_BEEN_UPDATED: "Dine indstillinger er opdateret.",
    },
    se: {
      SETTINGS: "Inställningar",
      HOW_WOULD_YOU_LIKE_US_TO_COMMUNICATE:
        "Välj hur du vill att vi kommunicerar till dig:",
      VIA_EMAIL: "Via e-post",
      I_WOULD_LIKE_TO_RECEIVE_VIA_EMAIL:
        "Jag vill gärna få recept, tips och erbjudanden via e-post.",
      VIA_SMS: "Via SMS",
      I_WOULD_LIKE_TO_RECEIVE_VIA_SMS:
        "Jag vill gärna få recept, tips och erbjudanden via SMS.",
      VIA_PHONE: "Per telefon",
      I_WOULD_LIKE_TO_RECEIVE_VIA_PHONE:
        "Jag vill gärna få recept, tips och erbjudanden på telefon.",
      VIA_SOCIAL_MEDIA: "Via sociala medier",
      I_WOULD_LIKE_TO_RECEIVE_VIA_SOCIAL_MEDIA:
        "Jag vill gärna få recept, tips och erbjudanden på sociala medier.",
      // extra checbox on LMK
      VIA_PRINT: "Via brev",
      I_WOULD_LIKE_TO_RECEIVE_VIA_PRINT:
        "Jag vill gärna få recept, tips och erbjudanden via brev",
      SAVE_BUTTON_TEXT: "Spara ändringar",
      REMINDERS: "Påminnelse på SMS",
      GET_NOTIFIED_BEFORE_DEADLINE:
        "Få besked om min kommande beställning innan deadline för ändringar och eventuella avbokningar.",
      WILL_BE_NOTIFIED_BEFORE_DEADLINE:
        "Jag vill bli meddelad om min kommande beställning innan tidsfristen för ändringar gått ut.",
      CAN_TAKE_UP_TO_24_HOURS:
        "Vänligen observera att det kan ta upp till 24 timmar innan din ändring registrerats.",
      YOUR_SETTINGS_HAVE_BEEN_UPDATED: "Dina inställningar har uppdaterats.",
    },
  } as const
)[language];
